<div class="d-flex">
  <!-- Toggle Button -->

  <!-- Sidebar -->
  <aside *ngIf="!sharedService.standalone" class="d-flex flex-column position-relative flex-shrink-0 border-end"
    [ngStyle]="{'width': sharedService.shareObject.sidebarOpen ? '250px' : '60px'}">
    <div
      class="px-3 d-flex align-items-center justify-content-{{sharedService.shareObject.sidebarOpen ? 'end' : 'center'}}">
      <span class="{{sharedService.shareObject.sidebarOpen? '' : 'mb-2'}}" role="button" (click)="toggleSidebar()">
        <i class="bi"
          [ngClass]="{'bi-arrow-left-circle-fill fs-3': sharedService.shareObject.sidebarOpen, 'bi-arrow-right-circle-fill fs-5': !sharedService.shareObject.sidebarOpen}"></i>
      </span>
      <!-- logo -->
    </div>
    <ul class="nav flex-column">

      <!-- Các item không có group: hiển thị bình thường -->
      <li *ngFor="let item of ungroupedUI" routerLinkActive="active text-white" id="{{ item.name }}"
        class="nav-item py-0 w-100" role="button">
        <a class="nav-link py-1 position-relative" routerLink="{{ item.path }}">
          <i class="{{ item.icon }} me-3 fs-5" (mouseover)="showHelp(item)"></i>
          <span *ngIf="item.showHelp === true && !sharedService.shareObject.sidebarOpen" class="help-text">
            <span>{{ item.name | translate }}</span>
          </span>
          <span *ngIf="sharedService.shareObject.sidebarOpen" class="">{{ item.name | translate }}</span>
        </a>
      </li>
      <div class="accordion" id="accordionExample">
        <li class="pe-0" *ngFor="let group of groupedUI; let i = index">
          <div class="accordion">
            <div class="accordion-item border-0">
              <span class="accordion-header" id="spend">
                <a class="accordion-button py-1 px-3 nav-link acc {{group.collapsed? '':'collapsed'}}" type="button"
                  data-bs-toggle="collapse" attr.data-bs-target="#group-{{i}}" attr.aria-expanded="{{group.collapsed}}"
                  attr.aria-controls="group-{{i}}">
                  <i class="{{group.items[0].icon}} me-3 fs-5"></i>
                  <span *ngIf="sharedService.shareObject.sidebarOpen" class="">{{ group.title | translate }}</span>
                </a>
              </span>
              <div id="group-{{i}}" data-bs-parent="#accordionExample"
                class="accordion-collapse collapse {{group.collapsed ?'show':''}}" aria-labelledby="spend">
                <div class="accordion-body p-0">
                  <div class="responsive hover-scroll">
                    <ul class="nav nav-pills bg-accordion">
                      <li *ngFor="let item of group.items" routerLinkActive="bg-active" id="{{ item.name }}"
                        class="nav-item w-100" role="button">
                        <a class="nav-link py-1 position-relative" routerLink="{{ item.path }}">
                          <i class="{{ item.icon }} me-3 fs-5" (mouseover)="showHelp(item)"></i>
                          <span *ngIf="item.showHelp === true && !sharedService.shareObject.sidebarOpen"
                            class="help-text">
                            <span>{{ item.name | translate }}</span>
                          </span>
                          <span *ngIf="sharedService.shareObject.sidebarOpen">{{ item.name | translate }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
      <li class="nav-item w-100" role="button" (click)="sharedService.logout()">
        <a class="nav-link d-flex align-items-center">
          <i class="bi bi-box-arrow-left me-3  fs-5"></i>
          <span *ngIf="sharedService.shareObject.sidebarOpen">{{"menu_logout"|translate}}</span>
        </a>
      </li>
    </ul>


  </aside>

  <!-- Main Content -->
  <!-- <div class="content flex-grow-1"> -->
  <div class="content main-content flex-grow-1 px-2 py-1">
    <router-outlet></router-outlet>
  </div>
</div>
